<template>
  <BaseModal
    :id="id"
    class="editorial-upload-modal"
    :heading="$t('Upload Files and Create Assets')"
    :on-cancel="onClose"
    :on-confirm="onStartUpload"
    :confirm-text="busy ? $t('Uploading...') : $t('Start Upload')"
    :cancel-text="$t('Cancel')"
    :disable-confirm-button="!canStartUpload"
    :disable-cancel-button="busy"
    :close-on-backdrop-click="false"
    :hide-header-cancel-button="true"
    :initial-focus="() => $refs.editorialUpload?.$refs?.addFileButton"
  >
    <EditorialUpload
      ref="editorialUpload"
      :tokens="{
        createAsset: user.token,
        createMediaFile: user.token,
        uploadMediaFileComplete: user.token,
        generateThumbnails: user.token,
      }"
      :allow-multiple="allowMultiple"
      :locale-code="localeCode"
      :content-url="domains.contentDomain"
      :init-files="options.initFiles"
      @busy="busy = $event"
      @can-upload="canStartUpload = $event"
    />
  </BaseModal>
</template>

<script>
import { get } from 'lodash-es';
import { mapActions, mapState } from 'pinia';
import BaseModal from '@/components/modals/BaseModal.vue';
import EditorialUpload from '@/components/editorial-upload/EditorialUpload.vue';
import assetSelectionModal from '@/mixins/assetSelectionModal';
import * as types from '@/lib/constants/store';
import {
  useUserStore,
  useModalStore,
} from '@/stores';

export default {
  name: 'EditorialUploadModal',
  components: {
    BaseModal,
    EditorialUpload,
  },
  props: {
    id: {
      type: String, // used for opening and closing modal
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mixins: [assetSelectionModal],
  data() {
    return {
      canStartUpload: false,
      busy: false,
    };
  },
  computed: {
    ...mapState(useUserStore, [
      'user',
      'domains',
    ]),
    localeCode() {
      return get(this, 'user.analytics_data.locale.code', 'en');
    },
    allowMultiple() {
      return get(this, 'options.allowMultiple', true);
    },
  },
  methods: {
    ...mapActions(useModalStore, [
      types.CLOSE_MODAL,
    ]),
    onClose() {
      this[types.CLOSE_MODAL]({ id: this.id });
    },
    async onStartUpload() {
      try {
        const assets = await this.$refs.editorialUpload.upload();
        this.assetSelection = assets;
        this.onConfirm();
      } catch (error) {
        // Errors displayed in modal.
      }
    },
  },
};
</script>

<style lang="stylus">
.editorial-upload-modal {
  .comet-modal {
    width: 580px;
  }

  @media screen and (min-width: $comet-breakpoints-tablet-landscape) {
    .comet-modal {
      width: 798px;
    }
  }
}
</style>
